<template>
  <ConfigLayout current="staff">
    <ConfigPage title="スタッフの並べ替え" showBack @back="goBack">
      <template #header>
        <Button @click="goBack">キャンセル</Button>
        <Button class="is-lead" @click="onSave" :disabled="!changed">保存</Button>
      </template>
      <DraggableTable
        class="staff-list"
        v-model="staffOrders"
        :columns="[{ key: 'name', name: 'スタッフ名' }]"
        :minItemHeight="56"
        :loading="busy"
      >
      </DraggableTable>
    </ConfigPage>
  </ConfigLayout>
</template>

<script>
import { mapState } from 'vuex'
import { isEqual } from 'lodash'
import ConfigLayout from '@/components/templates/ConfigLayout'
import ConfigPage from '@/components/templates/ConfigPage'
import Button from '@/components/atoms/Button'
import DraggableTable from '@/components/molecules/DraggableTable'

export default {
  name: 'StaffOrder',
  components: {
    ConfigLayout,
    ConfigPage,
    Button,
    DraggableTable,
  },
  data() {
    return {
      staffIds: null,
    }
  },
  computed: {
    ...mapState({
      staffs: state => state.staffs,
      busy: state => state.staffs.busy,
    }),
    staffOrders: {
      get() {
        return (this.staffIds || this.staffs.allIds).map(id => this.staffs.byId[id])
      },
      set(staffs) {
        this.staffIds = Array.isArray(staffs) && staffs.map(staff => staff.id)
      },
    },
    changed() {
      return !!this.staffIds && !isEqual(this.staffIds, this.staffs.allIds)
    },
  },
  watch: {
    changed() {
      this.$store.commit('app/editing', this.changed)
    },
  },
  mounted() {
    this.$store.dispatch('staffs/get')
  },
  methods: {
    async onSave() {
      if (await this.$store.dispatch('staffs/saveOrder', this.staffIds)) {
        this.goBack()
      }
    },
    goBack() {
      this.$store.commit('app/editing', false)
      window.history.length > 1 ? this.$router.back() : this.$router.push({ name: 'staff' })
    },
  },
}
</script>
